import styled, { ThemeProvider } from 'styled-components';
import { MotionConfig } from 'framer-motion';
import theme from './config/theme';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { SEO } from './components/SEO';
import { NavigationItem, SEOData } from './types';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
`;

function App() {
  // Navigation configuration
  const navigation: NavigationItem[] = [
    { label: 'Inicio', href: '#inicio' },
    { label: 'Servicios', href: '#servicios' },
    { label: 'Proyectos', href: '#proyectos' },
    { label: 'Clientes', href: '#clientes' },
    { label: 'Contacto', href: '#contacto' },
  ];

  // SEO configuration
  const seoData: SEOData = {
    title: 'Vidrería la Cañadita. Vidrios y Aluminios',
    description: 'Vidrería la Cañadita. Especialistas en Puertas, Ventanas, Cancelería de baños, Barandales, Espejos, Vidrios de diferentes espesor. Trabajos garantizados en Santa María Atzompa.',
    keywords: [
      'vidrería la cañadita',
      'vidrios y aluminios oaxaca',
      'puertas oaxaca',
      'ventanas oaxaca',
      'cancelería baños oaxaca',
      'barandales oaxaca',
      'espejos oaxaca',
      'vidrios diferentes espesor',
      'trabajos garantizados',
      'santa maría atzompa',
      'la cañadita',
      'vidrios templados',
      'aluminios',
      'cancelería',
      'presupuesto gratis vidrios',
      'instalación profesional'
    ],
    canonical: 'https://vidrerialacanadita.kinetia.com.mx'
  };

  return (
    <ThemeProvider theme={theme}>
      <MotionConfig reducedMotion="user">
        <SEO data={seoData} />
        <AppContainer>
          <Header navigation={navigation} />
          <MainContent>
            <Hero />
            <Services />
            <Gallery />
            <Testimonials />
            <Contact />
          </MainContent>
          <Footer />
        </AppContainer>
      </MotionConfig>
    </ThemeProvider>
  );
}

export default App;
